export default __webpack_public_path__ + "static/media/logo.c9414749.svg";